import React from 'react'
import {Link} from 'react-router-dom' 
import './home.css'
import sample from './video.mp4'
import data from './data.csv'

const Home = () => {
    return (
        <div>
            <section class="showcase">
                <div class="video-container">
                    <video autoPlay loop muted>
                        <source src={sample} type='video/mp4' />
                    </video>
                </div>
                <div class="content">
                    <h1>Text Analytics Done Right !</h1>
                    <h5>Text analytics for your product reviews in just few clicks</h5>
                    <Link to="/dashboard">
                        <a className="btn">Get Started</a>
                    </Link>
                    <a href={data} download className="btn download">Download Data</a>
                </div>
            </section>
        </div>
    )
}

export default Home